import axios from "axios";

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

export const setToken = (token = "") => {
  instance.defaults.headers.common.Authorization = `Token ${token}`;
};

export const { get, post, delete: del, put } = instance;
